export default __webpack_public_path__ + "static/media/attendance.8560e35a.svg";